import * as React from 'react'
import { cn } from '@/utilities/cn'
import { Container } from '@/components/Container'
import { Breadcrumbs } from '@/components/Breadcrumbs'

export interface DetailBreadcrumb {
  label: string
  href?: string
}

export interface DetailPageLayoutProps {
  breadcrumbs?: DetailBreadcrumb[]
  /** Main column content (typically richer markup, takes 2 cols on lg). */
  main: React.ReactNode
  /** Sidebar column (1 col on lg). Optional — falls back to single-column when absent. */
  sidebar?: React.ReactNode
  className?: string
}

export const DetailPageLayout: React.FC<DetailPageLayoutProps> = ({
  breadcrumbs,
  main,
  sidebar,
  className,
}) => {
  const crumbs = breadcrumbs?.map((c, i) => ({
    label: c.label,
    href: c.href,
    current: i === breadcrumbs.length - 1,
  }))
  return (
    <Container className={cn('py-8 lg:py-12', className)}>
      {crumbs && crumbs.length > 0 ? <Breadcrumbs items={crumbs} /> : null}
      {sidebar ? (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">{main}</div>
          <aside className="space-y-6">{sidebar}</aside>
        </div>
      ) : (
        <div>{main}</div>
      )}
    </Container>
  )
}

export default DetailPageLayout
